var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1855 1.2725C8.56551 1.38859 7.00977 1.9533 5.69246 2.90341C4.37516 3.85352 3.34831 5.15152 2.72684 6.65211C2.10538 8.1527 1.91385 9.79665 2.17368 11.3999C2.43351 13.0032 3.13446 14.5025 4.19805 15.73L10.1855 9.74125V1.2725ZM11.4355 1.2725V9.375H19.538C19.3874 7.27589 18.4854 5.30135 16.9973 3.81324C15.5092 2.32513 13.5347 1.42312 11.4355 1.2725ZM19.538 10.625H11.0693L5.0818 16.6125C6.30932 17.6757 7.80852 18.3764 9.4116 18.636C11.0147 18.8956 12.6584 18.704 14.1588 18.0826C15.6591 17.4612 16.957 16.4345 17.907 15.1174C18.857 13.8003 19.4218 12.2448 19.538 10.625ZM0.810547 10C0.810547 7.34784 1.86412 4.8043 3.73948 2.92893C5.61484 1.05357 8.15838 0 10.8105 0C13.4627 0 16.0063 1.05357 17.8816 2.92893C19.757 4.8043 20.8105 7.34784 20.8105 10C20.8105 12.6522 19.757 15.1957 17.8816 17.0711C16.0063 18.9464 13.4627 20 10.8105 20C8.15838 20 5.61484 18.9464 3.73948 17.0711C1.86412 15.1957 0.810547 12.6522 0.810547 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.d3c837867182c9eae8cfc7a640d1c604.svg";
export { ForwardRef as ReactComponent };